import React, {useEffect, useRef, useState} from "react";
import {Tooltip, Typography} from "antd";
import {numberFormat, tokens} from "./tokens";

/**
 * Плашка с ключевым числом. Значение форматируется по-русски, подпись
 * переносится, а не обрезается — на телефоне плашки идут в одну колонку.
 *
 * При изменении значения плашка коротко подсвечивается: пользователь двигает
 * ползунок сценария и должен видеть, какие именно числа на это откликнулись.
 */
export const StatCard = ({label, value, unit, hint, tone = 'default'}) => {
    const color = tone === 'accent' ? tokens.accent
        : tone === 'danger' ? tokens.danger
            : tone === 'primary' ? tokens.primary
                : tokens.ink

    const shown = typeof value === 'number' && isFinite(value)
        ? numberFormat.format(Math.round(value))
        : (value ?? '—')

    const [changed, setChanged] = useState(false)
    const previous = useRef(shown)

    useEffect(() => {
        if (previous.current === shown) return
        previous.current = shown
        setChanged(true)
        const timer = setTimeout(() => setChanged(false), 700)
        return () => clearTimeout(timer)
    }, [shown])

    return <Tooltip title={hint}>
        <div className={`stat-card${changed ? ' stat-card--changed' : ''}`}>
            <Typography.Text type={"secondary"} className={"stat-card__label"}>{label}</Typography.Text>
            <div className={"stat-card__value"}>
                <span style={{color}}>{shown}</span>
                {unit && <span className={"stat-card__unit"}>{unit}</span>}
            </div>
        </div>
    </Tooltip>
}

export default StatCard
